export function arrayToJSONString (inputArr) {
  return JSON.stringify(inputArr, null)
    .replace(/\"/g, '')
    .replace(/},{/g, ' | ')
    .replace(/[\[{}\]]/g, '')
}



// WEBPACK FOOTER //
// ./src/utilities/filters/array-to-jsonstring.js